(function () {
    'use strict';

    angular.module("imApp").factory("batchDeliveryAddService", ['$ihttp', function ($ihttp) {
        let service = {
            listBatchDeliverySelectSuppliers: function (parms) {
                return $ihttp.post({
                    method: 283,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
